import React from 'react';

/**
 * The two big yellow buttons under the search box on the farmer, distributor
 * and shopkeeper homes (beta feedback): the role's two main jobs, side by
 * side. buttons: [{ icon, label, onClick, testId }].
 */
export default function HomeBigButtons({ buttons }) {
  return (
    <div className="grid grid-cols-2 gap-3 mt-3 mb-4">
      {buttons.map(({ icon: Icon, label, onClick, testId }) => (
        <button key={testId} type="button" onClick={onClick}
                className="min-h-[132px] rounded-3xl bg-[#FFC107] text-farm-forest px-3 py-4 shadow-md flex flex-col items-center justify-center gap-2 text-center active:scale-[0.98] transition-transform"
                data-testid={testId}>
          <Icon className="w-12 h-12 shrink-0" strokeWidth={2} />
          <span className="font-heading text-lg font-extrabold leading-tight break-words">{label}</span>
        </button>
      ))}
    </div>
  );
}
